import { isMemberOf } from "../validation/narrow";

export const RECORD_OBJECT_TYPES = [
  "orders",
  "leads",
  "quotes",
  "products",
  "accounts",
  "contacts",
  "outreach",
] as const;

export type RecordObjectType = (typeof RECORD_OBJECT_TYPES)[number];

export function isRecordObjectType(value: string): value is RecordObjectType {
  return isMemberOf(RECORD_OBJECT_TYPES, value);
}
